// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableViewMenu-sortbySection__YZDxM{display:flex;flex-direction:column;gap:var(--size-1);padding:var(--size-0) var(--size-4) var(--size-4) var(--size-4)}.TableViewMenu-sectionTitle__I9AMz{color:var(--text-strong);font:var(--font-body-500-spacious);font-feature-settings:var(--feature-settings-body-500-spacious);letter-spacing:var(--letter-spacing-body-500-spacious)}.TableViewMenu-columnTitle__QSvvv{padding:var(--size-0) var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortbySection": "TableViewMenu-sortbySection__YZDxM",
	"sectionTitle": "TableViewMenu-sectionTitle__I9AMz",
	"columnTitle": "TableViewMenu-columnTitle__QSvvv"
};
export default ___CSS_LOADER_EXPORT___;
